// router.effects.ts
import { inject, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, tap } from 'rxjs/operators';
import { addRouteToHistory } from '../actions/shared.action';


@Injectable()
export class RouterEffects {
    private router = inject(Router);
    private store = inject(Store);

    trackRouteHistory$ = createEffect(() => {
        return this.router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            tap(event => {
                this.store.dispatch(addRouteToHistory({ url: event.urlAfterRedirects }));
            })
        );

    }, { dispatch: false });
}
